import api from './client';

// =============================================================================
// Safety Check-In API — Spec 111 (Emergency Check-In Timer)
// =============================================================================

export interface SafetyCheckin {
  id: number;
  publicId: string;
  organizationId: number | string;
  userId: number | string;
  status: string;
  durationMinutes: number;
  startedAt: string;
  expiresAt: string;
  confirmedAt: string | null;
  escalatedAt: string | null;
  escalationLevel: number;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

/** A check-in as returned by GET /safety/check-in/:publicId/status — includes
 *  the at-risk user's privacy-safe display name + public id for a "Message" CTA.
 *  `notes` is deliberately absent: the owner's private activity notes are never
 *  sent to the status view (they'd be visible to Dominant viewers). */
export interface SafetyCheckinStatus extends Omit<SafetyCheckin, 'notes'> {
  userDisplayName: string;
  userPublicId: string;
}

export const safetyCheckinAPI = {
  start: (data: { durationMinutes: number; notes?: string }) =>
    api.post<{ success: true; data: SafetyCheckin }>('/safety/check-in/start', data),

  confirm: () =>
    api.post<{ success: true; data: SafetyCheckin }>('/safety/check-in/confirm'),

  cancel: () =>
    api.post<{ success: true; data: SafetyCheckin }>('/safety/check-in/cancel'),

  getActive: () =>
    api.get<{ success: true; data: SafetyCheckin | null }>('/safety/check-in/active'),

  /** GET a check-in's status as an org-viewer (self or a Dominant org member). */
  getStatus: (checkinId: string) =>
    api.get<{ success: true; data: SafetyCheckinStatus }>(`/safety/check-in/${checkinId}/status`),
};
